import Link from '../Link/Link'
import { ArrowWrapper } from './Pager.styles'
import ArrowLeftActiveIcon from '/public/assets/images/svg/arrow-left-active.svg'
import ArrowLeftInactiveIcon from '/public/assets/images/svg/arrow-left-inactive.svg'
import ArrowRightActiveIcon from '/public/assets/images/svg/arrow-right-active.svg'
import ArrowRightInactiveIcon from '/public/assets/images/svg/arrow-right-inactive.svg'

type Props = {
  direction: 'left' | 'right'
  active: boolean
  link: string
  onClick?: () => void
}

export const Arrow = ({ direction, active, link, onClick }: Props) => {
  let icon

  if (direction === 'left') {
    icon = active ? <ArrowLeftActiveIcon /> : <ArrowLeftInactiveIcon />
  } else {
    icon = active ? <ArrowRightActiveIcon /> : <ArrowRightInactiveIcon />
  }

  return (
    <ArrowWrapper onClick={onClick}>
      {link ? <Link href={active ? link : undefined}>{icon}</Link> : icon}
    </ArrowWrapper>
  )
}
